import api from '@pray/shared/utils/api';

export async function replyToTestimonial({ artistId, testimonialId, body }) {
  if (!artistId) throw Error('Artist ID is required');
  if (!testimonialId) throw Error('Testimonial ID is required');
  if (!body) throw Error('Reply body is required');

  const url = `/web/studio/artists/${artistId}/testimonials/${testimonialId}/reply`;
  const response = await api.executePostRequest(url, { reply_body: body });

  return response.data;
}
